import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";


let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  accountId:'xx', //Id da conta da IUGU para funcionar  a integração com o cartão de credito
  Loja: "globalpays",
  UserStorage: "YjFbguoHG0CoArRW+DmbfA==",
  UserToken: "AN7RaoXJZUaSJjSpHgIhgw==",
  UrlApi: "https://hlg-ecommerce-glp-api.primecase.com.br/api",
  UrlLoja: "https://hlg-ecommerce-glp-web.primecase.com.br",
  UrlServiceHost: "https://dev2-pri-svc-api.primecase.com.br/",
  OrgId: "xx",
  ProviderMerchantId: "xx"
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "rgb(20, 199, 113)",
      light: "#B799F2",
      //lighter: "#ece6f7",
      dark: darkenColor("rgb(20, 199, 113)", 10), // Escurece em 20%
    },
    secondary: {
      main: "#7E7296",
    },
    error: {
      main: "#a91c1c",
    },
  
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
